import React, { useState } from "react";
import Footer from "../component/Footer";
import "../Text Modification Formatting/text.css";

const PlainTextConverter = () => {
  const [text, setText] = useState(""); // Single state for text

  const calculateTextStatistics = (text) => {
    const words = text
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0);
    const letters = text.replace(/\s+/g, "").length;
    const sentences = text
      .split(/[.!?]+/)
      .filter((sentence) => sentence.trim().length > 0);
    const lines = text.split("\n");
    return {
      wordCount: words.length,
      letterCount: letters,
      sentenceCount: sentences.length,
      lineCount: lines.length,
    };
  };

  const handleDownload = () => {
    const element = document.createElement("a");
    const file = new Blob([text], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = "converted_text.txt";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(text);
  };

  const handleClear = () => {
    setText("");
  };

  const { wordCount, letterCount, sentenceCount, lineCount } =
    calculateTextStatistics(text);

  return (
    <div className="container">
      <main>
        <h1>Rabbit Case</h1>
        <div className="content">
          <h2>Plain Text Converter</h2>
          <p>
            Are you struggling with losing the numbering, bulleted, or tabbed
            formatting when copying and pasting rich text into an online form?
            Convert Case's Plain Text Converter is here to help. Our online
            utility preserves the benefits of formatting while removing the
            frustrating background embedded code, allowing you to easily copy
            and paste from one application or form to another. No more
            frustration, just seamless productivity.
          </p>
          <div className="textarea-container">
            <textarea
              className="textarea-animated"
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="Start typing your notes here..."
              rows="10"
            />
          </div>

          <div className="stats-text">
            Words: {wordCount} | Letters: {letterCount} | Sentences:{" "}
            {sentenceCount} | Lines: {lineCount}
          </div>

          <div className="btn1-container">
            <button class="btn-421" onClick={handleDownload}>
              Download Text
            </button>
            <button class="btn-421" onClick={handleCopy}>
              Copy to Clipboard
            </button>
            <button class="btn-421" onClick={handleClear}>
              Clear
            </button>
          </div>
        </div>

        <br />
        <div className="content1">
          <h3>How to Use Convert Case's Plain Text Converter</h3>
          <p>
            Using our Plain Text Converter is simple. Just copy the rich text
            you want to convert and paste it into the converter. Our tool will
            automatically remove all the embedded code and preserve the
            numbered, bulleted, and tabbed formatting. You can then copy the
            plain text and use it in any online form or application without
            losing your formatting. Say goodbye to manual reformatting and hello
            to seamless productivity with Convert Case's Plain Text Converter.
          </p>
        </div>

        <br />

        <div className="content1">
          <h3>
            What types of formatting does the Plain Text Converter preserve?
          </h3>
          <p>
            Our converter preserves numbered, bulleted, and tabbed formatting,
            making it easy for you to copy and paste your text into any online
            form or application without losing your formatting.
          </p>
        </div>
        <br />
        <div className="content1">
          <h3>Can I use the Plain Text Converter on my mobile device?</h3>
          <p>
            Yes, you can use our converter on any device with internet access,
            including your mobile device.
          </p>
        </div>
        <br />
        <div className="content1">
          <h3>Is the Plain Text Converter free to use?</h3>
          <p>
            Yes, our converter is completely free to use. Simply visit our
            website and start converting your rich text to plain text today.
          </p>
        </div>
        <br />
        <div className="content1">
          <h3>
            Does the Plain Text Converter support languages other than English?
          </h3>
          <p>
            Yes, our converter supports a wide range of languages, including
            non-Latin scripts. Simply copy and paste your text into the
            converter and let us do the rest.
          </p>
        </div>
        <br />
        <div className="content1">
          <h3>
            How does the Plain Text Converter differ from other online
            converters?
          </h3>
          <p>
            Our converter not only removes the frustrating embedded code from
            your rich text, but also preserves your formatting, making it easy
            for you to use your text in any online form or application without
            having to manually reformat it.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PlainTextConverter;
